import store from '../../store';

export default (word) => {
  const { getState } = store;
  const { initial } = getState();
  const { scales } = initial;
  const { scaleCandidatos, scaleIndividual } = scales;
  const dictionary = {
    candidatos: scaleCandidatos,
    individual: scaleIndividual,
  };

  if (dictionary[word]) {
    return dictionary[word]();
  }

  return word;
};




// WEBPACK FOOTER //
// ./src/components/mapa/dict.js